<template>
  <div :class="{english:lang == 'EN'}">
    <div class="hidden-xs">
      <div class="partner" ref="partner">
        <div class="wow animated fadeInUp" style="display:flex;align-items: center;flex-direction: column;">
          <div class="partner-title">{{$t(title)}}</div>
        </div>
        <div style="width: 100%;align-items: center;display: flex;justify-content: center;">
          <div class="partner-ul animated wow fadeInUp">
            <div class="item" v-for="item in tecPartnerArr">
              <img :src="item.img"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="visible-xs">
      <div class="partner" ref="partner">
        <div class="wow animated fadeInUp" style="display:flex;align-items: center;flex-direction: column;">
          <div class="partner-title">{{$t(title)}}</div>
        </div>
        <div style="width: 100%;align-items: center;display: flex;justify-content: center;">
          <div class="partner-ul">
            <div class="item animated wow fadeInUp" v-for="item in tecPartnerArr">
              <img :src="item.img"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import {WOW} from 'wowjs'
  import {mapGetters} from 'vuex'

  export default {
    name: 'MainPartner',
    components: {},
    props: {},
    data() {
      return {
        title: 'home.partner',
        tecPartnerArr: [
          {
            img: require('../../../assets/img/common/c1.png')
          },
          {
            img: require('../../../assets/img/common/c2.png')
          },
          {
            img: require('../../../assets/img/common/c3.png')
          },
          {
            img: require('../../../assets/img/common/c4.png')
          },
          {
            img: require('../../../assets/img/common/c5.png')
          },
          {
            img: require('../../../assets/img/common/c6.png')
          },
          // {
          //   img: require('../../../assets/img/common/partner7.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner8.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner9.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner10.png')
          // },
          //
          // {
          //   img: require('../../../assets/img/common/partner11.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner12.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner13.png')
          // },
          //
          // {
          //   img: require('../../../assets/img/common/partner14.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner15.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner16.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner17.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner18.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner19.png')
          // },
          // {
          //   img: require('../../../assets/img/common/partner20.png')
          // }
        ]
      }
    },
    methods: {},
    mounted() {
      const wow = new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: false,
        live: false
      })
      wow.init()
    },
    computed: {
      ...mapGetters(['lang']),
      getComponentName() {
        return 'MainPartner'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .partner {
    position: relative;
    width: 100%;
    background: #FFFFFF;

    .partner-title {
      margin-top: 3rem;
      font-size: 3rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      letter-spacing: 0.25rem;
      line-height: 3.38rem;
    }

    .underline {
      max-width: 9.75rem;
      margin-top: 1.5rem;
    }

    .partner-ul {
      width: 100%;
      max-width: 75rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap:wrap;
      margin: 2rem 0 2rem 0;

      .item {
        /*cursor: pointer;*/
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 0.5rem 3.13rem 0.5rem ;

        img {
          height: 11.28rem;
        }
      }
    }
  }

  .visible-xs {
    .partner-title {
      margin-top: 2rem;
      font-size: 1.5rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: rgba(63, 74, 93, 1);
      letter-spacing: 0.25rem;
      line-height: 4.38rem;
    }

    .partner-ul {
      width: 90%;
      max-width: 90%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin: 1rem 0 2rem 0;

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 45%;
        margin: 2.5%;
        background: #FFFFFF;
        img {
          height: 6rem;
          width: 6rem;
        }
      }
    }
  }

  .english {
    .partner-title {
      letter-spacing: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/home/MainPartner.vue